import { ActionKeys } from '~/actions/constants';
import { ActionTypes } from '~/actions/index';
import InvoiceItem from '~/types/InvoiceItem';
import { getFailed, getNotRequested, getRequesting, getSuccess } from '~/utils/fetchable';

export type InvoiceItemsState = {
  readonly exportURL: Requestable<string, string>;
  readonly invoiceItems: Requestable<InvoiceItem[], Error>;
  readonly displayInvoiceItems: Requestable<InvoiceItem[], string>; // Used to display invoice items in invoice download page
  readonly page: number;
  readonly pageCount: number;
};

export const initialState: InvoiceItemsState = {
  exportURL: getNotRequested(),
  invoiceItems: getNotRequested(),
  displayInvoiceItems: getNotRequested(),
  page: 1,
  pageCount: 1,
};

function invoiceItemsReducer(
  state: InvoiceItemsState = initialState,
  action: ActionTypes,
): InvoiceItemsState {
  switch (action.type) {
    case ActionKeys.TRANSACTIONS_INVOICE_ITEMS_EXPORT:
      return {
        ...state,
        exportURL: getRequesting(),
      };
    case ActionKeys.TRANSACTIONS_INVOICE_ITEMS_EXPORT_RESET:
      return {
        ...state,
        exportURL: getNotRequested(),
      };
    case ActionKeys.TRANSACTIONS_INVOICE_ITEMS_EXPORT_SUCCESS:
      return {
        ...state,
        exportURL: getSuccess(action.payload.exportURL),
      };
    case ActionKeys.TRANSACTIONS_INVOICE_ITEMS_EXPORT_ERROR:
      return {
        ...state,
        exportURL: getFailed(action.payload.err),
      };
    case ActionKeys.TRANSACTIONS_INVOICE_ITEMS_FETCH:
      return {
        ...state,
        exportURL: getNotRequested(),
        invoiceItems: getRequesting(),
      };
    case ActionKeys.TRANSACTIONS_INVOICE_ITEMS_FETCH_SUCCESS:
      const { page, pageCount } = action.payload;
      return {
        ...state,
        page,
        pageCount,
        invoiceItems: getSuccess(action.payload.invoiceItems),
      };
    case ActionKeys.TRANSACTIONS_INVOICE_ITEMS_FETCH_ERROR:
      return {
        ...state,
        invoiceItems: getFailed(action.payload.err),
      };
    case ActionKeys.DISPLAY_INVOICE_INVOICE_ITEMS_FETCH:
      return {
        ...state,
        displayInvoiceItems: getRequesting(),
      };
    case ActionKeys.DISPLAY_INVOICE_INVOICE_ITEMS_FETCH_SUCCESS:
      return {
        ...state,
        displayInvoiceItems: getSuccess(action.payload.invoiceItems),
      };
    case ActionKeys.DISPLAY_INVOICE_INVOICE_ITEMS_FETCH_ERROR:
      return {
        ...state,
        displayInvoiceItems: getFailed(action.payload.err),
      };
    default:
      return state;
  }
}

export default invoiceItemsReducer;
